import { DbEventTable } from '../dbevents/DbEventTable';
import { useDbEvents } from '../dbevents/useDbEvents';
import { EmptyState, ErrorText, Loading } from '../ui';

/**
 * 요청 상세의 DB 사건 구획 (9회차 결정 4).
 *
 * 요청 구간은 "이 쿼리가 3.2초 걸렸다"까지만 안다. 그 3.2초가 잠금을 기다린 시간이었는지는
 * DB 감시가 남긴 사건에만 있다. 그 요청의 번호로 조회한다(막은 쪽으로 걸린 것도 함께 온다).
 */
export function DbEvents({ traceId }: { traceId: string }) {
  const { loading, rows, error } = useDbEvents({ traceId });

  if (loading) return <Loading />;
  if (error !== undefined) return <ErrorText>{error}</ErrorText>;
  if (rows.length === 0) {
    return <EmptyState title="이 요청에 걸린 DB 사건이 없다" />;
  }
  return <DbEventTable rows={rows} showTrace={false} />;
}
